import { useGateValue } from "@statsig/react-bindings";

export const useEnableWebstream = (): boolean => {
  return useGateValue("enable_webstream");
};
